<template>
    <div class="pt-2">
        <div class="m-8 border-2 border-green-500 bg-gray-200 mb-8">
            <form @submit.prevent="update">
                <div class="p-8 pb-2 flex flex-wrap" @change="dirtyForm()">
                    <textarea-input :value="form.contact_details" @input="form.contact_details = $event.target.value" class="mb-4" label="Sponsor name and address"/>
                    <label class="form-label w-full text-left">Amount of award:</label>
                    <input type="text" class="form-input w-1/2" :value="form.amount_of_award" @input="form.amount_of_award = $event.target.value" label="Amount of award"/>
                </div>
                <div v-if="successMessage" class="success-message m-8 w-auto">{{ successMessage }}</div>
                <div v-if="serverError" class="server-error m-8">{{ serverError }}</div>
                <div class="lg:flex justify-end w-full pb-2">
                    <div class="flex items-center ml-8 mt-8 lg:ml-0 lg:mt-0">
                        <div class="border border-gray-300 bg-gray-300 p-2 rounded hover:bg-gray-100 text-black-600 cursor-pointer" @click="cancelForm()">Cancel</div>
                    </div>
                    <div class="relative w-auto lg:w-1/3 mx-8">
                        <application-component-save-button :disabled="formDirty" class="w-full flex btn-green ml-auto mt-8 md:inline-block text-center" type="submit">
                            Save New Sponsor Item
                            <div class="lds-ring-container absolute top-10" v-if="loading"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>
                        </application-component-save-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import TextInput from '@/shared/TextInput'
import TextareaInput from '@/shared/TextareaInput'
import ApplicationComponentSaveButton from '@/shared/ApplicationComponentSaveButton'

export default {
  components: {
    ApplicationComponentSaveButton,
    TextInput,
    TextareaInput,
  },
  props:{
    applicationData: Object,
  },
  data() {
    return {
        form: ({
            contact_details: '',
            amount_of_award: '',
        }),
        formDirty: false,
        loading: false,
        successMessage: '',
        serverError: '',
    }
  },
  methods: {
    update() {
      this.loading = true,
      this.$store.dispatch('newSponsorItem', {
        sponsorData: this.form,
        applicationRef: this.$route.params.id,
        applicationData: this.applicationData,
      })
      .then((response) => {
        this.loading = false
        this.serverError = '',
        this.successMessage = response.data
        setTimeout(function(){
            window.location.search += '&section=fundingDetailsShow';
        }, 1000);
      })
      .catch(error => {
        this.loading = false
        this.serverError = error.response.data
        this.successMessage = ''
      })
      this.formDirty = false
    },
    dirtyForm() {
        this.formDirty = true
        this.successMessage = ''
    },
    cancelForm () {
         this.$emit('cancelForm')
     }
  }
}
</script>
